declare const window: Window & typeof globalThis & { FB: any; fbAsyncInit: any };

const formatFbUser = (fbUser: any, access_token: string): ISocialProfile => {
  return {
    provider_name: "facebook",
    token_type: "access_token",
    access_token,
    full_name: fbUser.name || `${fbUser.first_name} ${fbUser.last_name}`,
    email: fbUser.email,
  };
};

const locale = "en_US";
const version = "v15.0";
const fields = "id,name,first_name,last_name,email";

export function initFacebookSdk() {
  const appConfig = useRuntimeConfig().public;
  const facebookAppId = appConfig.APP_CUSTOMER.app_config.app_id_facebook;

  return new Promise((_resolve) => {
    // wait for facebook sdk to initialize before starting the vue app
    window.fbAsyncInit = function () {
      window.FB.init({ appId: facebookAppId, cookie: true, xfbml: true, version, autoLogAppEvents: true });
    };

    // load facebook sdk script
    (function (d, s: "script", id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id))
        return;
      const js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode?.insertBefore(js, fjs);
    }(document, "script", "facebook-jssdk"));
  });
}

export function getFacebookLoginStatus(): Promise<ISocialProfile> {
  return new Promise((resolve, reject) => {
    window.FB.getLoginStatus((response: any) => {
      if (response.status !== "connected" || !response.authResponse)
        return reject(new Error("No user is currently logged in with Facebook"));

      window.FB.api("/me", { locale, fields }, (fbUser: any) => resolve(formatFbUser(fbUser, response.authResponse.accessToken)));
    });
  });
}

export async function loginFacebook(): Promise<ISocialProfile> {
  return new Promise((resolve, reject) => {
    window.FB.login((response: any) => {
      if (response.status !== "connected" || !response.authResponse)
        return reject(new Error("Facebook authentication failed"));

      window.FB.api("/me", { locale, fields }, (fbUser: any) => resolve(formatFbUser(fbUser, response.authResponse.accessToken)));
    }, { scope: "public_profile,email" });
  });
}

export function logoutFacebook(): Promise<void> {
  return new Promise(resolve => window.FB.logout(resolve));
}
